module.exports = __webpack_public_path__ + "static/media/icon-lock.5d6f1c0f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/icon-lock.svg
// module id = 333
// module chunks = 0